import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./metodoApice.css";
import { FaCheck, FaArrowRight } from "react-icons/fa";

export default function MetodoApice() {
  const navigate = useNavigate();
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.2 },
    );

    const elements = document.querySelectorAll(".animate-on-scroll");
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const etapas = [
    {
      letra: "A",
      nome: "Análise",
      descricao: "Entendemos a fundo seu negócio, mercado e concorrência.",
    },
    {
      letra: "P",
      nome: "Planejamento",
      descricao: "Traçamos a estratégia certa para seus objetivos.",
    },
    {
      letra: "I",
      nome: "Integração",
      descricao: "Unificamos marketing e tecnologia em um só sistema.",
    },
    {
      letra: "C",
      nome: "Conversão",
      descricao: "Transformamos estratégia em vendas reais.",
    },
    {
      letra: "E",
      nome: "Expansão",
      descricao: "Escalamos os resultados de forma sustentável.",
    },
  ];

  const beneficios = [
    "Um raio-x completo do seu momento digital atual",
    "Os pontos de perda de vendas que você ainda não enxerga",
    "Um plano de ação prático, sem termos técnicos complicados",
    "Prioridades claras: o que resolver primeiro para ver resultado",
  ];

  const handleDiagnostico = () => {
    navigate("/diagnostico");
  };

  return (
    <section className="metodo-apice-page" ref={sectionRef}>
      <div className="metodo-apice-container">
        {/* TÍTULO */}
        <div className="metodo-header animate-on-scroll">
          <h1 className="metodo-title">
            O Método <span className="highlight-rosa">ÁPICE</span>
          </h1>
          <p className="metodo-subtitle">
            Uma metodologia em 5 etapas para levar sua marca ao próximo nível
          </p>
        </div>

        {/* TIMELINE HORIZONTAL */}
        <div className="timeline-wrapper animate-on-scroll">
          <div className="timeline-scroll">
            <div className="timeline-container">
              {etapas.map((etapa, index) => (
                <div key={index} className="timeline-item">
                  <div className="timeline-letra">
                    <span className="letra-circle">{etapa.letra}</span>
                  </div>

                  {index < etapas.length - 1 && (
                    <div className="timeline-linha">
                      <div className="linha"></div>
                    </div>
                  )}

                  <div className="timeline-info">
                    <h3 className="timeline-nome">{etapa.nome}</h3>
                    <p className="timeline-desc">{etapa.descricao}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* DIVISÓRIA */}
        <div className="divisoria animate-on-scroll"></div>

        {/* SEÇÃO DE BENEFÍCIOS */}
        <div className="beneficios-section animate-on-scroll">
          <h2 className="beneficios-title">
            O QUE VOCÊ RECEBE COM O{" "}
            <span className="highlight-rosa">DIAGNÓSTICO</span>
          </h2>
          <div className="beneficios-grid">
            {beneficios.map((beneficio, index) => (
              <div key={index} className="beneficio-item">
                <FaCheck className="beneficio-icon" />
                <span className="beneficio-text">{beneficio}</span>
              </div>
            ))}
          </div>
        </div>

        {/* CTA FINAL */}
        <div className="cta-wrapper animate-on-scroll">
          <div className="cta-reforco">
            <p className="cta-reforco-text">
              Um diagnóstico completo do seu negócio digital, com plano de ação
              personalizado, por menos do que custa um almoço para dois.
            </p>
          </div>
          <button className="cta-btn" onClick={handleDiagnostico}>
            QUERO MEU DIAGNÓSTICO POR{" "}
            <span className="preco-destaque">R$ 97,00</span>
            <FaArrowRight className="cta-icon" />
          </button>
        </div>
      </div>
    </section>
  );
}
